var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"padding-top":"100px"},attrs:{"id":"us-home"}},[_vm._v(" 授权成功, 正在加载... ")])}
var staticRenderFns = []

export { render, staticRenderFns }